import { LoadingStatus, LOADING_STATUS } from 'shared/constants';

export const checkIsLoading = (statusLoading?: LoadingStatus) => (
  statusLoading === LOADING_STATUS.load
);

export const checkIsLoadingDone = (statusLoading?: LoadingStatus) => (
  statusLoading === LOADING_STATUS.done
);

export const checkIsLoadingError = (statusLoading?: LoadingStatus) => (
  statusLoading === LOADING_STATUS.error
);

export const checkIsLoadingAbort = (statusLoading?: LoadingStatus) => (
  statusLoading === LOADING_STATUS.abort
);